import { useEffect } from 'react';
import { useGetPortalFeaturesQuery } from '../../userManagement/queries/getPortalFeatures.query.generated';
import { setFeatureConfigs } from '@store';
import type { FeatureConfig } from '@features/userManagement/types';

/**
 * Loads feature configs (tier/scope metadata) into the global store.
 * Mounted once in Layout alongside PermissionsPollingProvider.
 */
const FeatureConfigLoader = ({ children }: { children: React.ReactNode }) => {
  const { data } = useGetPortalFeaturesQuery();

  useEffect(() => {
    if (!data?.features) return;
    const configs: Record<string, FeatureConfig | null> = {};
    for (const f of data.features) {
      configs[f.name] = (f.config as FeatureConfig) ?? null;
    }
    setFeatureConfigs(configs);
  }, [data]);

  return <>{children}</>;
};

export default FeatureConfigLoader;
